"use client";

import { useState } from "react";
import { startThread } from "@/lib/message-actions";
import SubmitButton from "./SubmitButton";

type Props = {
  listingId: string;
  hostName: string;
  bookingId?: string;
  variant?: "default" | "small";
  triggerLabel?: string;
};

export default function ContactHostButton({
  listingId,
  hostName,
  bookingId,
  variant = "default",
  triggerLabel = "Contact host",
}: Props) {
  const [open, setOpen] = useState(false);
  const placeholder = bookingId
    ? "Hi! A quick question about my booking…"
    : "Hi! I have a question about your listing…";
  const triggerClass =
    variant === "small"
      ? "text-xs px-2 py-1 border border-neutral-300 rounded hover:bg-neutral-50"
      : "text-sm px-3 py-1.5 border border-neutral-300 rounded-lg hover:bg-neutral-50";

  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className={triggerClass}>
        {triggerLabel}
      </button>
      {open ? (
        <div
          className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4"
          onClick={() => setOpen(false)}
        >
          <div
            className="bg-white rounded-xl max-w-md w-full p-5"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="font-semibold">Message {hostName}</h2>
            {bookingId ? (
              <p className="text-xs text-neutral-500 mt-1">
                We&apos;ll attach this conversation to your booking.
              </p>
            ) : null}
            <form action={startThread} className="mt-3 space-y-3">
              <input type="hidden" name="listingId" value={listingId} />
              {bookingId ? <input type="hidden" name="bookingId" value={bookingId} /> : null}
              <textarea
                name="body"
                required
                rows={4}
                maxLength={4000}
                placeholder={placeholder}
                className="w-full border border-neutral-200 rounded-lg p-3 text-sm outline-none focus:border-rose-600"
              />
              <div className="flex justify-end gap-2">
                <button
                  type="button"
                  onClick={() => setOpen(false)}
                  className="text-sm px-3 py-2 hover:bg-neutral-50 rounded-lg"
                >
                  Cancel
                </button>
                <SubmitButton pendingLabel="Sending…">Send</SubmitButton>
              </div>
            </form>
          </div>
        </div>
      ) : null}
    </>
  );
}
